'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _ImageCache = require('./ImageCache');

var _ImageCache2 = _interopRequireDefault(_ImageCache);

var ImageHelper = {
    loadImage: function loadImage(url) {
        var image = _ImageCache2['default'].get(url);

        return new Promise(function (resolve, reject) {
            var handleSuccess = function handleSuccess() {
                resolve(image);
            };
            var handleError = function handleError() {
                console.error('IMAGE FAIL', image);
                reject(image);
            };

            if (image.naturalWidth && image.naturalHeight) {
                // image is loaded, go ahead and change the state
                handleSuccess();
            } else {
                image.addEventListener('load', handleSuccess, false);
                image.addEventListener('error', handleError, false);
            }
        });
    },

    loadImages: function loadImages(urls) {
        var promises = urls.map(this.loadImage.bind(this));
        return Promise.all(promises);
    },

    // preload without caring about the result
    stuffImages: function stuffImages(urls) {
        _ImageCache2['default'].stuff(urls);
    }
};

exports['default'] = ImageHelper;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-preload/lib/ImageHelper.js
 ** module id = 524
 ** module chunks = 0
 **/